import { render, staticRenderFns } from "./ReferenceSection.vue?vue&type=template&id=61ca2001&"
import script from "./ReferenceSection.vue?vue&type=script&lang=js&"
export * from "./ReferenceSection.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceSection.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports